const IconTicketOutline = ({ className }) => {
    return (
        <svg viewBox='0 0 20 16' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M11 1V3M11 13V15M11 7V9M1 3V5C1.79565 5 2.55871 5.31607 3.12132 5.87868C3.68393 6.44129 4 7.20435 4 8C4 8.79565 3.68393 9.55871 3.12132 10.1213C2.55871 10.6839 1.79565 11 1 11V13C1 14.1 1.9 15 3 15H17C17.5304 15 18.0391 14.7893 18.4142 14.4142C18.7893 14.0391 19 13.5304 19 13V11C18.2044 11 17.4413 10.6839 16.8787 10.1213C16.3161 9.55871 16 8.79565 16 8C16 7.20435 16.3161 6.44129 16.8787 5.87868C17.4413 5.31607 18.2044 5 19 5V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconTicketOutline;
